import { render, staticRenderFns } from "./InvestmentRank.vue?vue&type=template&id=7d49cac1&scoped=true"
import script from "./InvestmentRank.vue?vue&type=script&lang=js"
export * from "./InvestmentRank.vue?vue&type=script&lang=js"
import style0 from "./InvestmentRank.vue?vue&type=style&index=0&id=7d49cac1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d49cac1",
  null
  
)

export default component.exports